import { useState, type FormEvent } from "react";
import { heroStats } from "@/mocks/spotlight";

type HeroProps = {
  onSearch: (query: string) => void;
};

export default function Hero({ onSearch }: HeroProps) {
  const [value, setValue] = useState("");

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSearch(value.trim());
  };

  return (
    <section id="home" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20editorial%20background%20with%20deep%20crimson%20and%20warm%20cream%20gradients%2C%20soft%20film%20grain%2C%20blurred%20bokeh%20light%20spots%2C%20dramatic%20contrast%2C%20minimalist%20magazine%20cover%20mood%2C%20no%20text&width=1600&height=1000&seq=hl-hero-bg&orientation=landscape"
          alt="黑料看点热点话题讨论氛围背景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/70 to-foreground-950/90"></div>
      </div>

      <div className="relative w-full">
        <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6 py-20 md:py-32">
          <div className="animate-fade-up max-w-3xl">
            <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/50 bg-foreground-950/40 px-3 py-1.5 font-label text-xs text-accent-300">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-pulse-line"></i>
              </span>
              热点话题 · 实时更新
            </span>

            <h2 className="mt-5 font-heading text-3xl md:text-5xl font-bold leading-tight text-background-50">
              看清今天的争议，听懂每一种立场
            </h2>

            <p className="mt-4 max-w-2xl text-sm md:text-base leading-relaxed text-background-200">
              黑料看点汇聚网络热点话题讨论，实时跟进网友观点与评论风向。围绕热点事件展开多角度讨论，把争议热评和观点碰撞一并呈现，让你快速掌握舆论动态，参与话题不吃亏。
            </p>

            <form onSubmit={handleSubmit} className="mt-8 w-full max-w-xl" role="search">
              <div className="flex flex-col gap-3 sm:flex-row">
                <div className="relative flex-1">
                  <span className="pointer-events-none absolute left-4 top-1/2 flex h-5 w-5 -translate-y-1/2 items-center justify-center text-foreground-400">
                    <i className="ri-search-line"></i>
                  </span>
                  <input
                    type="text"
                    value={value}
                    onChange={(event) => setValue(event.target.value)}
                    placeholder="搜索你关心的话题，如：结局争议、限流"
                    aria-label="搜索话题"
                    className="w-full rounded-md border border-background-300 bg-background-50/95 py-3 pl-11 pr-4 font-label text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-400/40"
                  />
                </div>
                <button
                  type="submit"
                  className="inline-flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-400"
                >
                  <i className="ri-search-2-line"></i>
                  搜索话题
                </button>
              </div>
            </form>

            <div className="mt-10 grid w-full grid-cols-2 gap-4 md:grid-cols-4 md:gap-6">
              {heroStats.map((item) => (
                <div key={item.id} className="rounded-lg border border-background-50/15 bg-foreground-950/40 px-4 py-4">
                  <p className="font-heading text-xl md:text-2xl font-bold text-background-50">
                    {item.value}
                    <span className="ml-1 font-label text-xs font-normal text-accent-300">{item.unit}</span>
                  </p>
                  <p className="mt-1 font-label text-xs text-background-300">{item.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}